<template>
   <v-card class="background-2" elevation="0">
        <v-card-title class="pa-3">
            <p>Personal Access Tokens</p>
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-dialog v-model="showCreateTokenForm" max-width="800px" persistent scrollable>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                v-on="{ ...tooltip }"
                                @click="showCreateTokenForm = true"
                                icon>
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>  
                        </template>
                        <v-card class="background-2 round-card">
                            <v-card-title class="pa-3">
                                <p class="pl-2 pl-xl-3">Nuovo Token</p>
                            </v-card-title>     
                            <v-divider></v-divider>

                            <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                                <v-form ref="form">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                    @keyup.enter="store"
                                                    v-model="form.name"
                                                    label="Nome*"
                                                    required
                                                    outlined
                                                    dense
                                                    hint="Qualcosa che i tuoi utenti riconosceranno e di cui si fideranno."
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" v-for="scope in scopes" :key="'scope_'+scope.id">
                                                <v-checkbox
                                                    @click="toggleScope(scope.id)"
                                                    :checked="scopeIsAssigned(scope.id)"
                                                    :label="scope.id"
                                                ></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-form>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="showCreateTokenForm = false">
                                    Chiudi
                                </v-btn>
                                <v-btn color="info" text @click="store" :loading="loading">
                                    Salva
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <span>Nuovo Token</span>
            </v-tooltip>
        </v-card-title>

        <v-card-text class="px-0">
            <v-data-table
                :headers="headers"
                :items="tokens"
                :items-per-page="5"
                class="elevation-0 background-2"
                :mobile-breakpoint="0"
                :footer-props="{
                    'items-per-page-options': [5, 10, 25, 50,  { text: 'Tutti', value: -1 }],
                    showFirstLastPage: true
                }">
                <template v-slot:item="{item, headers}">
                    <tr>
                        <template v-for="(header, h) in headers">
                            <td v-if="header.value === 'actions'" :key="h">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon small class="mx-0" @click.stop="revoke(item)">
                                            <v-icon color="red">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Elimina</span>
                                </v-tooltip>
						    </td>
                            <td v-else-if="header.type === 'date'" :key="h">
                                <div>
                                    {{ item[header.value] | date }}
                                </div>
						    </td>
                            <td v-else :key="h">
							    {{ (item[header.value]) }}
						    </td>
                        </template>
                    </tr>
                </template>

            </v-data-table>
        </v-card-text>
        <v-divider></v-divider>

        <v-dialog v-model="showAccessTokenDialog" max-width="800px" persistent scrollable>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Personal Access Token</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                    Ecco il tuo nuovo token di accesso personale. Questa è l'unica volta che verrà mostrato, quindi non perderlo!
                    È ora possibile utilizzare questo token per effettuare richieste API.

                    <v-textarea rows="10" :value="accessToken"></v-textarea>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="showAccessTokenDialog = false">
                    Chiudi
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

    export default {
        data() {
            return {
                accessToken: null,
                tokens: [],
                scopes: [],
                headers: [
                    { text: 'Azioni', value: 'actions', sortable: false },
                    { text: 'Nome', value: 'name' },
                    { text: 'Creato il', value: 'created_at', type: 'date' },
                    { text: 'Scadenza', value: 'expires_at', type: 'date' },
                ],
                form: {
                    name: '',
                    scopes: [],
                    errors: []
                },
                showCreateTokenForm: false,
                showAccessTokenDialog: false,
                loading: false
            }
        },

        mounted() {
            this.getTokens()
            this.getScopes()
        },

        methods: {

            getTokens() {
                this.axios.get('/oauth/personal-access-tokens').then(response => {
                    this.tokens = response.data
                })
            },

            getScopes() {
                this.axios.get('/oauth/scopes').then(response => {
                    this.scopes = response.data
                })
            },

            store() {
                this.accessToken = null
                this.form.errors = []

                this.axios.post('/oauth/personal-access-tokens', this.form).then(response => {
                    this.form.name = ''
                    this.form.scopes = []
                    this.form.errors = []

                    this.tokens.push(response.data.token)

                    this.showAccessToken(response.data.accessToken)
                })
                .catch(error => {
                    if (typeof error.response.data === 'object') {
                        this.form.errors = _.flatten(_.toArray(error.response.data.errors))
                    } else {
                        this.form.errors = ['Something went wrong. Please try again.']
                    }
                })
            },

            toggleScope(scope) {
                if (this.scopeIsAssigned(scope)) {
                    this.form.scopes = _.reject(this.form.scopes, s => s == scope)
                } else {
                    this.form.scopes.push(scope)
                }
            },

            scopeIsAssigned(scope) {
                return _.indexOf(this.form.scopes, scope) >= 0
            },

            showAccessToken(accessToken) {
                this.showCreateTokenForm = false
                this.accessToken = accessToken
                this.showAccessTokenDialog = true
            },

            revoke(token) {
                this.axios.delete('/oauth/personal-access-tokens/' + token.id).then(response => {
                    this.getTokens()
                })
            }
        }
    }
</script>
